module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-radio",
    class: {
      'is-disabled': _vm.disabled
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "z-radio__label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "z-radio__input"
  }, [_c('input', {
    staticClass: "z-radio__control",
    attrs: {
      "type": "radio"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "z-radio__circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d99b313a!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/radio/src/radio.vue
// module id = 145
// module chunks = 2 3